import { Button, Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import HighlightedCode from "examples/HighlightedCode";
import DataTable from "examples/Tables/DataTable";
import { useMaterialUIController } from "context";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import sampleResponses from "static-data/sample-responses";
import Flow from "../assets/flow-aoapi.svg";
import FlowLight from "../assets/flow-aoapi-light.svg";
import FlowIUJA from "../assets/flow-iuja.svg";
import FlowIUJALight from "../assets/flow-iuja-light.svg";
import AppFlow from "../assets/ao-user.svg";
import AppFlowLight from "../assets/ao-user-light.svg";
import EncryptingJSON from "../code/encrypting-json-data";
import EncryptingJSONLight from "../code/encrypting-json-data-light";
import EncryptingFormData from "../code/encrypting-form-data-and-attaching-files";
import EncryptingFormDataLight from "../code/encrypting-form-data-and-attaching-files-light";
import PropTypes from "prop-types";
import useCopyToClipboard from "../../../../custom-hooks/useCopyToClipboard";
import DocImage from "components/DocImage";

const ApiDescription = ({ data, search }) => {
  // Fetch Color Modes
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [, copy] = useCopyToClipboard();

  const renderChildItems = (child) => {
    return child.map((item) => (
      <li key={item.value}>
        <a href={"#" + item.value}>{item.value}</a>
      </li>
    ));
  };

  const renderGeneralListTitleWithLink = (generalListTitleWithLink) => {
    return generalListTitleWithLink.map((list) => (
      <li key={list.title}>
        <h6>{list?.title}</h6>
        <ol>{list?.child && renderChildItems(list.child)}</ol>
      </li>
    ));
  };
  return (
    <>
      {Object.keys(data)?.map((val) => {
        let filtered = data[val].children?.filter((childVal) => {
          if (search.toLowerCase() === "") {
            return childVal;
          } else {
            return (
              childVal?.mainHeading
                ?.toLowerCase()
                ?.includes(search.toLowerCase()) ||
              childVal?.subHeading
                ?.toLowerCase()
                ?.includes(search.toLowerCase()) ||
              childVal?.generalMainHeading
                ?.toLowerCase()
                ?.includes(search.toLowerCase()) ||
              childVal?.subHeadingDesc
                ?.toLowerCase()
                ?.includes(search.toLowerCase()) ||
              childVal?.generalDescOne
                ?.toLowerCase()
                ?.includes(search.toLowerCase()) ||
              childVal?.dataFieldDesc
                ?.toLowerCase()
                ?.includes(search.toLowerCase()) ||
              childVal?.updateRequestTitle
                ?.toLowerCase()
                ?.includes(search.toLowerCase()) ||
              childVal?.updateRequestDes
                ?.toLowerCase()
                ?.includes(search.toLowerCase()) ||
              (childVal?.generalDescTwo !== undefined &&
                childVal?.generalDescTwo.map((val) => {
                  return val.valOne
                    ?.toLowerCase()
                    ?.includes(search.toLowerCase());
                })) ||
              (childVal?.generalDescTwo !== undefined &&
                childVal?.generalDescTwo.map((val) => {
                  return val.valTwo
                    ?.toLowerCase()
                    ?.includes(search.toLowerCase());
                }))
            );
          }
        });

        if (filtered.length === 0) {
          return (
            <MDTypography
              variant="h3"
              fontWeight="regular"
              fontFamily="inherit"
              textAlign="center"
              lineHeight={2}
              id="no-data-found"
              key="no-results"
            >
              No Results Found!
            </MDTypography>
          );
        } else {
          return filtered.map((childVal, childInd) => (
            <>
              <Grid
                container
                xs={12}
                mt={4}
                key={childInd?.mainGridId}
                id={childVal?.mainGridId}
              >
                <MDBox>
                  {childVal?.generalMainHeading && (
                    <MDTypography
                      variant="h4"
                      fontWeight="medium"
                      fontFamily="inherit"
                      lineHeight={1.5}
                      id={childVal?.mainGridId}
                    >
                      {childVal?.generalMainHeading}
                    </MDTypography>
                  )}
                  {childVal?.subData && (
                    <>
                      {childVal?.subData?.map((data, index) => (
                        <>
                          <MDTypography
                            variant="h5"
                            fontWeight="medium"
                            fontFamily="inherit"
                            lineHeight={1.5}
                            id={childVal?.mainGridId}
                          >
                            {data?.SubHeading}
                          </MDTypography>
                          <p>
                            <MDTypography
                              variant="p"
                              fontSize="14px"
                              fontWeight="regular"
                              fontFamily="inherit"
                              lineHeight={2}
                            >
                              {data?.SubDesc}
                            </MDTypography>
                          </p>
                          {index === 0 && (
                            <MDBox>
                              {/* <EJD /> */}
                              {darkMode ? (
                                <EncryptingJSON />
                              ) : (
                                <EncryptingJSONLight />
                              )}
                            </MDBox>
                          )}
                          {index > "0" && (
                            <MDBox>
                              {/* <EJD /> */}
                              {darkMode ? (
                                <EncryptingFormData />
                              ) : (
                                <EncryptingFormDataLight />
                              )}
                            </MDBox>
                          )}
                        </>
                      ))}
                    </>
                  )}
                  {childVal?.generalDescOne && (
                    <p>
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                      >
                        {childVal?.generalDescOne}
                        <br />
                        {childVal?.generalList && (
                          <ul className="listings">
                            {childVal?.generalList?.map((list) => (
                              <li key={list}>{list}</li>
                            ))}
                          </ul>
                        )}
                        {childVal?.generalListWithLink && (
                          <ul
                            className={
                              darkMode ? "listings dark" : "listings light"
                            }
                          >
                            {childVal?.generalListWithLink?.map((list) => (
                              <li key={list?.value}>
                                <a href={"#" + list?.id}>{list?.value}</a>
                              </li>
                            ))}
                          </ul>
                        )}
                        {childVal?.generalDescTwo &&
                          childVal?.generalDescTwo.map((val, index) => (
                            <p key={val?.linkOne || val?.linkTwo || index}>
                              {val?.valOne && (
                                <>
                                  {val?.valOne}
                                  <a href={"#" + val?.linkOne}>
                                    {" "}
                                    {val?.linkOneDesc}{" "}
                                  </a>
                                </>
                              )}
                              {val?.valTwo && (
                                <>
                                  {val?.valTwo}
                                  <a href={"#" + val?.linkTwo}>
                                    {" "}
                                    {val?.linkTwoDesc}{" "}
                                  </a>
                                </>
                              )}
                            </p>
                          ))}

                        {childVal?.generalDescThree && (
                          <p>{childVal?.generalDescThree}</p>
                        )}

                        {childVal?.generalDescFour && (
                          <>
                            <p>{childVal?.generalDescFour}</p>
                            <br />
                            <br />
                          </>
                        )}
                        {childVal?.image && (
                          <>
                            <DocImage
                              src={darkMode ? Flow : FlowLight}
                              className="center-img"
                              alt="AO"
                            />
                            <i className="text-center d-block">
                              {childVal?.imageDesc}
                            </i>
                          </>
                        )}
                        {childVal?.imageTwo && (
                          <>
                            <DocImage
                              src={darkMode ? FlowIUJA : FlowIUJALight}
                              className="center-img"
                              alt="AO"
                            />
                            <i className="text-center d-block">
                              {childVal?.imageDesc}
                            </i>
                          </>
                        )}
                        {childVal?.imageThree && (
                          <>
                            <DocImage
                              src={darkMode ? Flow : FlowLight}
                              className="center-img"
                              alt="AO"
                            />
                            <i className="text-center d-block">
                              {childVal?.imageDesc}
                            </i>
                          </>
                        )}
                      </MDTypography>
                    </p>
                  )}

                  {childVal?.oaf && (
                    <p>
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                      >
                        {childVal?.generalDescOneOaf}
                        <br />
                        {childVal?.imageThreeOaf && (
                          <>
                            <DocImage
                              src={darkMode ? AppFlow : AppFlowLight}
                              className="center-img"
                              alt="AO App Flow"
                            />
                            <i className="text-center d-block">
                              {childVal?.imageDescOaf}
                            </i>
                            <br />
                          </>
                        )}
                        {childVal?.generalDescTwoOaf && (
                          <p>{childVal?.generalDescTwoOaf}</p>
                        )}
                        {childVal?.generalDescThreeOaf && (
                          <p>{childVal?.generalDescThreeOaf}</p>
                        )}
                        {childVal?.generalListOaf && (
                          <ul className="listings">
                            {childVal?.generalListOaf?.map((list) => (
                              <li key={list}>{list}</li>
                            ))}
                          </ul>
                        )}
                      </MDTypography>
                    </p>
                  )}
                  {childVal?.apiSpec && (
                    <>
                      {childVal?.apiSpecMainHeading && (
                        <MDTypography
                          variant="h4"
                          fontWeight="medium"
                          fontFamily="inherit"
                          lineHeight={1.5}
                          id={childVal?.mainGridId}
                        >
                          {childVal?.apiSpecMainHeading}
                        </MDTypography>
                      )}
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                      >
                        {childVal?.generalListTitleWithLink &&
                          renderGeneralListTitleWithLink(
                            childVal.generalListTitleWithLink
                          )}
                      </MDTypography>
                    </>
                  )}

                  {childVal?.generalDescWithLinkOne && (
                    <>
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                      >
                        {childVal?.generalDescWithLinkOne.desc}
                      </MDTypography>
                      <p className="doc-text" style={{ marginLeft: "10px" }}>
                        {childVal?.generalDescWithLinkOne.link}
                        <Button
                          variant="text"
                          className="copyiconparent"
                          onClick={() =>
                            copy(childVal?.generalDescWithLinkOne.link)
                          }
                        >
                          <ContentCopyIcon className="copyicon" />
                        </Button>
                      </p>
                      <br />
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                      >
                        {childVal?.generalDescWithLinkTwo.desc}
                      </MDTypography>
                      <p className="doc-text" style={{ marginLeft: "10px" }}>
                        {childVal?.generalDescWithLinkTwo.link}
                        <Button
                          variant="text"
                          className="copyiconparent"
                          onClick={() =>
                            copy(childVal?.generalDescWithLinkTwo.link)
                          }
                        >
                          <ContentCopyIcon className="copyicon" />
                        </Button>
                      </p>
                    </>
                  )}
                </MDBox>
              </Grid>
              {val !== "General_Data" && val !== "General_Data_Bottom" && (
                <Grid
                  container
                  xs={12}
                  mt={4}
                  key={childInd?.mainGridId}
                  id={childVal?.mainGridId}
                >
                  <Grid item xs={12} md={8} pr={2} key={childInd?.mainGridId}>
                    <MDBox>
                      {childVal?.mainHeading && (
                        <MDTypography
                          variant="h4"
                          fontWeight="medium"
                          fontFamily="inherit"
                          lineHeight={1.5}
                          id={childVal?.parentid}
                        >
                          {childVal?.mainHeading}
                        </MDTypography>
                      )}
                      {childVal?.mainHeadingDesc && (
                        <p>
                          <MDTypography
                            variant="p"
                            fontSize="14px"
                            fontWeight="regular"
                            fontFamily="inherit"
                            lineHeight={2}
                          >
                            {childVal?.mainHeadingDesc}
                          </MDTypography>
                        </p>
                      )}
                      <MDTypography
                        variant="h5"
                        fontWeight="medium"
                        fontFamily="inherit"
                        lineHeight={2}
                        id={childVal?.routeUrlId}
                      >
                        {childVal?.subHeading}
                      </MDTypography>
                      {childVal?.subHeadingDesc && (
                        <p>
                          <MDTypography
                            variant="p"
                            fontSize="14px"
                            fontWeight="regular"
                            fontFamily="inherit"
                            lineHeight={2}
                          >
                            {childVal?.subHeadingDesc}
                          </MDTypography>
                        </p>
                      )}
                      <MDTypography
                        variant="h5"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                        id={
                          val === "Token_Connect"
                            ? "token-connect-route-url"
                            : ""
                        }
                      >
                        {childVal?.endPointHeading}
                      </MDTypography>
                      <MDTypography
                        variant="h6"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={1}
                        className="post-badge"
                      >
                        POST
                      </MDTypography>
                      <MDTypography
                        variant="h6"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={1}
                        className="link-badge"
                      >
                        {childVal?.endPointDesc}
                        <Button
                          variant="text"
                          className="copyiconparent"
                          onClick={() => copy(childVal?.endPointDesc)}
                        >
                          <ContentCopyIcon className="copyicon" />
                        </Button>
                      </MDTypography>
                      <br />
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                      >
                        {childVal?.requestHeaderNote}
                      </MDTypography>
                      <br />

                      <MDBox mt={3}>
                        <MDTypography
                          variant="h5"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                          id="token-connect-headers"
                        >
                          {childVal?.requestHeader}
                        </MDTypography>
                        <p>
                          <MDTypography
                            variant="p"
                            fontSize="14px"
                            fontWeight="regular"
                            fontFamily="inherit"
                            lineHeight={2}
                          >
                            {childVal?.requestHeaderDesc}
                          </MDTypography>
                        </p>
                        <MDBox mt={3} className="table-doc">
                          <Card>
                            <MDBox
                              className={darkMode ? "dark-tbl" : "light-tbl"}
                            >
                              <DataTable
                                table={{
                                  columns:
                                    childVal?.requestHeaderTable?.columns,
                                  rows: childVal?.requestHeaderTable?.rows,
                                }}
                                isSorted={false}
                                entriesPerPage={{
                                  defaultValue: 1000,
                                }}
                                showTotalEntries
                                noEndBorder
                              />
                            </MDBox>
                          </Card>
                        </MDBox>
                        {val === "Token_Connect" ? (
                          <>
                            <p className="mt-3 mb-0">
                              <MDTypography
                                variant="p"
                                fontSize="14px"
                                fontWeight="regular"
                                fontFamily="inherit"
                                lineHeight={1}
                              >
                                <strong>Authorization:</strong>
                                {" Basic <BASE64[ClientId:ClientSecret]>"}
                              </MDTypography>
                            </p>
                            <p className="m-0">
                              <MDTypography
                                variant="p"
                                fontSize="14px"
                                fontWeight="regular"
                                fontFamily="inherit"
                                lineHeight={1}
                              >
                                <strong>Content-Type:</strong>{" "}
                                application/x-www-form-urlencoded
                              </MDTypography>
                            </p>
                            <p className="m-0">
                              <MDTypography
                                variant="p"
                                fontSize="14px"
                                fontWeight="regular"
                                fontFamily="inherit"
                                lineHeight={1}
                              >
                                <strong>Body:</strong> grant_type =
                                client_credentials
                              </MDTypography>
                            </p>
                          </>
                        ) : (
                          <MDBox mt={3}>
                            {childVal?.dataFieldHeading && (
                              <MDTypography
                                variant="h5"
                                fontWeight="regular"
                                fontFamily="inherit"
                                lineHeight={2}
                                id={childVal?.dataFeildId}
                              >
                                {childVal?.dataFieldHeading}
                              </MDTypography>
                            )}
                            {childVal?.dataFieldDesc && (
                              <p>
                                <MDTypography
                                  variant="p"
                                  fontSize="14px"
                                  fontWeight="regular"
                                  fontFamily="inherit"
                                  lineHeight={2}
                                >
                                  {childVal.dataFieldDesc}
                                </MDTypography>
                              </p>
                            )}
                            {childVal?.dataFieldTable && (
                              <MDBox mt={3} className="table-doc">
                                <Card>
                                  <MDBox
                                    className={
                                      darkMode ? "dark-tbl-ao" : "light-tbl-ao"
                                    }
                                  >
                                    <DataTable
                                      table={{
                                        columns:
                                          childVal?.dataFieldTable?.columns,
                                        rows: childVal?.dataFieldTable?.rows,
                                      }}
                                      isSorted={false}
                                      entriesPerPage={{
                                        defaultValue: 1000,
                                      }}
                                      showTotalEntries
                                      noEndBorder
                                    />
                                  </MDBox>
                                </Card>
                              </MDBox>
                            )}
                            {childVal?.updateRequestTitle && (
                              <MDTypography
                                variant="h6"
                                fontWeight="bold"
                                fontFamily="inherit"
                                lineHeight={2}
                                mt={6}
                              >
                                {childVal?.updateRequestTitle}
                              </MDTypography>
                            )}
                            {childVal?.updateRequestDes && (
                              <MDTypography
                                variant="p"
                                fontSize="14px"
                                fontWeight="regular"
                                fontFamily="inherit"
                                lineHeight={2}
                              >
                                {childVal.updateRequestDes}
                              </MDTypography>
                            )}
                          </MDBox>
                        )}
                      </MDBox>
                    </MDBox>
                  </Grid>
                  {childVal?.otherData && val !== "Token_Connect" && (
                    <Grid item xs={12} md={8} pr={2} key={childInd?.otherData}>
                      <MDBox>
                        <MDTypography
                          variant="h5"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          {!childVal?.otherData?.heading
                            ? ""
                            : childVal?.otherData?.heading}
                        </MDTypography>
                        {childVal?.otherData?.desc && (
                          <p>
                            <MDTypography
                              variant="p"
                              fontSize="14px"
                              fontWeight="regular"
                              fontFamily="inherit"
                              lineHeight={2}
                            >
                              {!childVal?.otherData?.desc
                                ? ""
                                : childVal?.otherData?.desc}
                            </MDTypography>
                          </p>
                        )}
                        {childVal?.otherData?.tableData && (
                          <MDBox mt={3} className="table-doc">
                            <Card>
                              <MDBox
                                className={
                                  darkMode ? "dark-tbl-ao" : "light-tbl-ao"
                                }
                              >
                                <DataTable
                                  table={{
                                    columns:
                                      childVal?.otherData?.tableData?.columns,
                                    rows: childVal?.otherData?.tableData?.rows,
                                  }}
                                  isSorted={false}
                                  entriesPerPage={{
                                    defaultValue: 1000,
                                  }}
                                  showTotalEntries
                                  noEndBorder
                                />
                              </MDBox>
                            </Card>
                          </MDBox>
                        )}
                        {childVal?.otherData?.updateRequestTitle && (
                          <MDTypography
                            variant="h6"
                            fontWeight="bold"
                            fontFamily="inherit"
                            lineHeight={2}
                            mt={6}
                          >
                            {childVal?.otherData?.updateRequestTitle}
                          </MDTypography>
                        )}
                        {childVal?.otherData?.updateRequestDes && (
                          <MDTypography
                            variant="p"
                            fontSize="14px"
                            fontWeight="regular"
                            fontFamily="inherit"
                            lineHeight={2}
                          >
                            {childVal?.otherData?.updateRequestDes}
                          </MDTypography>
                        )}
                      </MDBox>
                    </Grid>
                  )}
                  {childVal?.respObjKey && (
                    <Grid item xs={12} md={4} mt={3} key={childVal?.respObjKey}>
                      <MDTypography
                        variant="h6"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                        id="token-connect-login-api"
                      >
                        Response Object
                      </MDTypography>
                      <HighlightedCode
                        code={sampleResponses?.account_opening[
                          childVal?.respObjKey
                        ].trim()}
                      />
                    </Grid>
                  )}
                </Grid>
              )}
            </>
          ));
        }
      })}
    </>
  );
};
ApiDescription.propTypes = {
  data: PropTypes.any.isRequired,
  search: PropTypes.string.isRequired,
};

// PropTypes validation
ApiDescription.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      children: PropTypes.arrayOf(
        PropTypes.shape({
          mainHeading: PropTypes.string,
          subHeading: PropTypes.string,
          generalMainHeading: PropTypes.string,
          subHeadingDesc: PropTypes.string,
          generalDescOne: PropTypes.string,
          dataFieldDesc: PropTypes.string,
          updateRequestTitle: PropTypes.string,
          updateRequestDes: PropTypes.string,
          generalDescTwo: PropTypes.arrayOf(
            PropTypes.shape({
              valOne: PropTypes.string,
              valTwo: PropTypes.string,
            })
          ),
        })
      ),
    })
  ).isRequired,
  search: PropTypes.string.isRequired,
};
export default ApiDescription;
